// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import SurveyStep from "./survey-step.js"
import TeamSurvey from "./team-survey.js"
import TeamSurveyStepElement from "./team-survey-step-element.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "survey_step_id": {
      "column": {
        "default": null,
        "name": "survey_step_id",
        "null": false,
        "type": null
      },
      "name": "survey_step_id",
      "selected_by_default": null,
      "translated": null
    },
    "team_survey_id": {
      "column": {
        "default": null,
        "name": "team_survey_id",
        "null": false,
        "type": null
      },
      "name": "team_survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TeamSurveyStep",
  "collectionKey": "team_survey_steps",
  "collectionName": "team_survey_steps",
  "i18nKey": "team_survey_step",
  "camelizedLower": "teamSurveyStep",
  "name": "TeamSurveyStep",
  "nameDasherized": "team-survey-step",
  "pluralName": "team_survey_steps",
  "ransackable_associations": [
    {
      "className": "TeamSurveyStep::Audit",
      "collectionName": "team_survey_step_audits",
      "foreignKey": "team_survey_step_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepAudit",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "has_one",
      "resource_name": "ClassStep",
      "through": "school_class"
    },
    {
      "className": "TeamSurveyStep::Audit",
      "collectionName": "team_survey_step_audits",
      "foreignKey": "team_survey_step_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "TeamSurveyStepAudit",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": "school_class"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "team"
    },
    {
      "className": "SurveyStep",
      "collectionName": "survey_steps",
      "foreignKey": "survey_step_id",
      "name": "survey_step",
      "macro": "belongs_to",
      "resource_name": "SurveyStep",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "has_one",
      "resource_name": "Team",
      "through": "team_survey"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "TeamSurveyStepElement",
      "collectionName": "team_survey_step_elements",
      "foreignKey": "team_survey_step_id",
      "name": "team_survey_step_elements",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElement",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "survey_step_id",
      "column": {
        "default": null,
        "name": "survey_step_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "team_survey_id",
      "column": {
        "default": null,
        "name": "team_survey_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "SurveyStep",
      "collectionName": "survey_steps",
      "foreignKey": "survey_step_id",
      "name": "survey_step",
      "macro": "belongs_to",
      "resource_name": "SurveyStep",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "belongs_to",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "TeamSurveyStepElement",
      "collectionName": "team_survey_step_elements",
      "foreignKey": "team_survey_step_id",
      "name": "team_survey_step_elements",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElement",
      "through": null
    }
  ],
  "paramKey": "team_survey_step",
  "primaryKey": "id"
}

/** Frontend model for TeamSurveyStep. */
export default class TeamSurveyStep extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyStepId() {
    return this.readAttributeUnderscore("survey_step_id")
  }

  /** @returns {boolean} */
  hasSurveyStepId() {
    const value = this.surveyStepId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  teamSurveyId() {
    return this.readAttributeUnderscore("team_survey_id")
  }

  /** @returns {boolean} */
  hasTeamSurveyId() {
    const value = this.teamSurveyId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  previousStep(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "previous_step",
        primaryKey: this.primaryKey(),
        collectionName: "team_survey_steps",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./survey-step.js").default | null} */
  surveyStep() {
    return this._readBelongsToReflection({modelClass: SurveyStep, reflectionName: "survey_step"})
  }

  /** @returns {Promise<import("./survey-step.js").default | null>} */
  loadSurveyStep() {
    if (!("surveyStepId" in this)) throw new Error("Foreign key method wasn't defined: surveyStepId")

    const id = this.surveyStepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey_step",
        model: this,
        modelClass: SurveyStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey-step.js").default | null>} */
  ensureSurveyStepLoaded() {
    return this.ensureAssociationLoaded("survey_step")
  }

  /** @returns {import("./team-survey.js").default | null} */
  teamSurvey() {
    return this._readBelongsToReflection({modelClass: TeamSurvey, reflectionName: "team_survey"})
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  loadTeamSurvey() {
    if (!("teamSurveyId" in this)) throw new Error("Foreign key method wasn't defined: teamSurveyId")

    const id = this.teamSurveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team_survey",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./team-survey.js").default | null>} */
  ensureTeamSurveyLoaded() {
    return this.ensureAssociationLoaded("team_survey")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey-step-element.js").default>} */
  teamSurveyStepElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_survey_step_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_survey_step_elements",
        model: this,
        modelClass: TeamSurveyStepElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey-step-element.js").default>>} */
  loadTeamSurveyStepElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_survey_step_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_survey_step_elements",
        model: this,
        modelClass: TeamSurveyStepElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey-step-element.js").default>>} */
  ensureTeamSurveyStepElementsLoaded() {
    return this.ensureAssociationLoaded("team_survey_step_elements")
  }
}
